var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliverySchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#2C6ECB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2578 11.1803C23.9918 11.5827 24.6551 12.5966 25.4867 13.9922H22.2578V11.1803ZM12.1241 14.1094C12.4637 14.1094 12.7101 14.2733 12.7101 14.6562C12.7101 14.9793 12.4487 15.2413 12.1258 15.2422H8.58594C8.2623 15.2422 8 15.5046 8 15.8281C8 16.1518 8.2623 16.4141 8.58594 16.4141H13.8594C14.1861 16.4141 14.4476 16.6762 14.4476 17C14.4476 17.3236 14.1853 17.5859 13.8617 17.5859H8.58594C8.2623 17.5859 8 17.8482 8 18.1719C8 18.4955 8.2623 18.7578 8.58594 18.7578H9.875V20.5156C9.875 20.8393 10.1373 21.1016 10.4609 21.1016H11.6388C11.8487 22.1358 12.7626 22.8984 13.8398 22.8984C14.9171 22.8984 15.831 22.1358 16.0409 21.1016H21.9903C22.2003 22.1358 23.1141 22.8984 24.1914 22.8984C25.2687 22.8984 26.1825 22.1358 26.3925 21.1016H27.4141C27.7377 21.1016 28 20.8393 28 20.5156V17C28 15.2808 26.1866 15.1667 26.185 15.1641H21.6719C21.3482 15.1641 21.0859 14.9018 21.0859 14.5781V11.0625H10.4609C10.1373 11.0625 9.875 11.3248 9.875 11.6484V12.9375H9.17188C8.84824 12.9375 8.58594 13.1998 8.58594 13.5234C8.58594 13.8471 8.84824 14.1094 9.17188 14.1094H12.1241ZM24.951 19.8928C25.3705 20.3122 25.3705 20.9926 24.951 21.4121C24.2762 22.0868 23.1172 21.6068 23.1172 20.6523C23.1172 19.6981 24.2762 19.218 24.951 19.8928ZM14.5994 19.8928C15.0189 20.3122 15.0189 20.9926 14.5994 21.4121C13.9247 22.0868 12.7656 21.6068 12.7656 20.6523C12.7656 19.6981 13.9247 19.218 14.5994 19.8928Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverySchedule);
export default __webpack_public_path__ + "static/media/delivery_schedule.2e3d3704ac455bc1c8bc57258977d14c.svg";
export { ForwardRef as ReactComponent };